export default __webpack_public_path__ + "static/media/TV_Alego.0de78aa0.jpg";